import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d63l0cibdoed7v0v8plg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="bg-[#111111] text-white">
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Left Column */}
          <div className="md:col-span-5">
            <h3 className="text-2xl font-bold mb-3">Semeiks Law</h3>
            <p className="text-base text-white/50 mb-8">
              Practical legal help, without the nonsense.
            </p>
            
            <div className="mb-6">
              <p className="text-sm font-semibold mb-4">Legal insights delivered monthly</p>
              <form id="newsletter-form" data-readdy-form onSubmit={handleSubmit} className="space-y-3">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email address"
                  required
                  className="w-full bg-transparent border-b border-white/20 pb-2 text-base text-white placeholder-white/40 focus:outline-none focus:border-[#C4704B] transition-colors"
                />
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="bg-[#C4704B] text-white px-6 py-2 rounded-lg text-sm font-medium hover:bg-[#A85A3A] transition-colors disabled:opacity-50 whitespace-nowrap"
                >
                  {isSubmitting ? 'Subscribing...' : 'Subscribe'}
                </button>
                {submitStatus === 'success' && (
                  <p className="text-sm text-white/60">Thank you for subscribing!</p>
                )}
                {submitStatus === 'error' && (
                  <p className="text-sm text-white/60">Something went wrong. Please try again.</p>
                )}
              </form>
            </div>
          </div>

          {/* Right Column - Navigation */}
          <div className="md:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
              {/* Services */}
              <div>
                <h4 className="text-base font-bold mb-4">Services</h4>
                <ul className="space-y-3">
                  <li>
                    <Link to="/services" className="text-sm text-white/50 hover:text-[#C4704B] transition-colors">
                      Contract Review
                    </Link>
                  </li>
                  <li>
                    <Link to="/services" className="text-sm text-white/50 hover:text-[#C4704B] transition-colors">
                      Business Formation
                    </Link>
                  </li>
                  <li>
                    <Link to="/services" className="text-sm text-white/50 hover:text-[#C4704B] transition-colors">
                      Commercial Agreements
                    </Link>
                  </li>
                  <li>
                    <Link to="/services" className="text-sm text-white/50 hover:text-[#C4704B] transition-colors">
                      Asset Protection
                    </Link>
                  </li>
                  <li>
                    <Link to="/services" className="text-sm text-white/50 hover:text-[#C4704B] transition-colors">
                      Business Counsel
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Firm */}
              <div>
                <h4 className="text-base font-bold mb-4">Firm</h4>
                <ul className="space-y-3">
                  <li>
                    <Link to="/about" className="text-sm text-white/50 hover:text-[#C4704B] transition-colors">
                      About
                    </Link>
                  </li>
                  <li>
                    <Link to="/about" className="text-sm text-white/50 hover:text-[#C4704B] transition-colors">
                      Approach
                    </Link>
                  </li>
                  <li>
                    <Link to="/services" className="text-sm text-white/50 hover:text-[#C4704B] transition-colors">
                      Services
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Connect */}
              <div>
                <h4 className="text-base font-bold mb-4">Connect</h4>
                <ul className="space-y-3">
                  <li>
                    <Link to="/contact" className="text-sm text-white/50 hover:text-[#C4704B] transition-colors">
                      Contact
                    </Link>
                  </li>
                  <li>
                    <Link to="/contact" className="text-sm text-white/50 hover:text-[#C4704B] transition-colors">
                      Schedule
                    </Link>
                  </li>
                  <li>
                    <a href="mailto:contact@semeikslaw.com" className="text-sm text-white/50 hover:text-[#C4704B] transition-colors">
                      Email
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-white/40">
            © {new Date().getFullYear()} Semeiks Law. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
